title: Fleet Admin
defaultEmptyText: (not set)
admin:
  title: Admin
spec:
  title: Specification
  basicData: Basic Data
  construction: Construction
  registration: Registration
  performance: Performance
  update:
    title: Update Specification
accommodation:
  title: Accommodation
  cabinsGuests: Cabins & Guests
  features: Features
  details: "Details:"
  cabins:
    title: Cabins
    new: New Cabin
features:
  title: Features
  amenities: 
    title: Amenities
    empty: (no amenities)
  toys: 
    title: Toys
    empty: (no toys)
  tenders:
    title: Tender & Other Boats
    add: New Tender
    empty: (no tenders)
  diving:
    title: Diving
rates:
  title: Area & Rates
  newArea: New Area
  empty: No operating areas selected.
  noRates: No rates added for this operating area
bookings:
  title: Calendar
  newReservation: Add Reservation
  newBasicCalendarEntry: Add Basic Calendar Entry
  calendarEntryCount_one: 1 Calendar Entry
  calendarEntryCount_other: "{{ count }} Calendar Entries"
  confirmedBookingsCount_one: 1 Confirmed Booking
  confirmedBookingsCount_other: "{{ count }} Confirmed Bookings"
  pickupLabel: Pickup
  dropOffLabel: Drop-off
  bookingsLabel: Bookings
  notificationEmails:
    title: "BCC reservation notification emails to:"
    empty: Nobody
    add: Add Recipient
personnel:
  title: Personnel
  captain: Captain
  owner: Owner
  onBoard: On Board
  crewProfiles:
    title: Crew Profiles
    new: Add Crew Profile
brochure:
  title: Brochure
  mainImage: Main Running Shot
  crewImage: Group Crew Photograph
  layoutImage: Yacht Layout Diagram
  gallery:
    title: Gallery
    addVideo: Add Video
  editorial:
    broadside: Broadside Editorial
    brochure: Brochure Editorial
    accommodation: Accommodation Description
    menu: Sample Menu
    testimonials: Testimonials
listingRenews: Listing renews on {{ date }}
